import React, { PureComponent } from 'react'
import { TableRow, TableCell } from '@material-ui/core'
import { EditableTextField, EditableSwitch } from '../common/EditableComponents'

class PaymentOptions extends PureComponent {
  onChange = (key, isCheckBox) => (e) => {
    const value = isCheckBox ? e.target.checked : e.target.value

    this.props.onChange(key, value)
  }

  render() {
    const { data = {}, editMode } = this.props

    return (
      <TableRow data-cy={'lbl-' + data.label.replace(/\s+/g, '')}>
        <TableCell>
          <EditableTextField value={data.label} valueToRender={data.label} editMode={false} />
        </TableCell>
        {data.active == false ? (
          <TableCell item xs={12} sm={6} md={6} lg={6}>
            <p>Unavailable</p>
          </TableCell>
        ) : (
          <TableCell item xs={12} sm={6} md={6} lg={6}>
            <EditableSwitch
              data-cy="chckbox-payment"
              checked={data.enabled}
              onChange={this.onChange('enabled', true)}
              valueToRender={data.enabled ? 'Enabled' : 'Not Enabled'}
              editMode={true}
            />
          </TableCell>
        )}
      </TableRow>
    )
  }
}

export default PaymentOptions



// WEBPACK FOOTER //
// ./src/components/PaymentOptions/index.js